module.exports = __webpack_public_path__ + "static/media/gray_circle.525e8e42.png";